module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_4_1-6465e973e64cb51cbb201575d9b51294.png";